export const SET_CURRENT_REQUEST = "SET_CURRENT_REQUEST";
export const RESOLVE_CURRENT_REQUEST = "RESOLVE_CURRENT_REQUEST";
